import { Trans } from "@coworker/locales";
import { NewReview } from "./NewReview";
import { AppBar } from "@coworker/apprestructured/src/layout/components/AppBar/AppBar";
import { ChartCard } from "../Chart/ChartCard";
import styled from "styled-components";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import GearIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/GearIconPath";
import { AppBarAction } from "@coworker/apprestructured/src/layout/components/AppBar/AppBar";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import { FilterPanel } from "@coworker/apprestructured/src/shared/filters/components/FilterPanel";
import { useShoppingToolsFilters } from "../Hooks/useShoppingToolsFilters";

const Line = styled("div")`
  width: 100%;
  border-bottom: 1px solid var(--grey150);
`;

const HorizontalLine = styled.hr`
  height: 1px;
  background-color: var(--grey200);
`;

export const ShoppingToolsOverview = () => {
  const navigate = useFixaNavigate();
  const shoppingToolsFilters = useShoppingToolsFilters({
    showRound: false,
    showPeriod: true,
  });

  const activeArea =
    shoppingToolsFilters.filterValues.find(
      (filter) => filter.filterId === "area"
    )?.value ?? "wholeStore";

  const appBarActions: AppBarAction[] = [
    {
      name: "close",
      icon: <FixaSSRIcon paths={GearIconPath} />,
      onClick: () => navigate("/shoppingtools/settings"),
      position: "right",
    },
  ];

  return (
    <div>
      <AppBar
        title={<Trans>shoppingToolsHeaderString</Trans>}
        actions={appBarActions}
      />
      <NewReview />
      <FilterPanel
        filterValues={shoppingToolsFilters.filterValues}
        setFilterValues={shoppingToolsFilters.setFilterValues}
        useFiltersFactory={shoppingToolsFilters.useFiltersFactory}
        feature="shopping-tools"
      />
      <HorizontalLine />
      {(activeArea === "showroomOW" || activeArea === "wholeStore") && (
        <ChartCard
          title={<Trans>showroomOWString</Trans>}
          showProgress
          area={"showroom"}
          shoppingToolsFilters={shoppingToolsFilters.filterValues}
        />
      )}
      {activeArea === "wholeStore" && <Line />}
      {(activeArea === "markethallOW" || activeArea === "wholeStore") && (
        <ChartCard
          title={<Trans>markethallOWString</Trans>}
          showProgress
          area={"markethall"}
          shoppingToolsFilters={shoppingToolsFilters.filterValues}
        />
      )}
      {activeArea === "wholeStore" && <Line />}
      {(activeArea === "otherAreaCashline" || activeArea === "wholeStore") && (
        <ChartCard
          title={<Trans>otherAreaCashlineString</Trans>}
          area={"cashline"}
          shoppingToolsFilters={shoppingToolsFilters.filterValues}
        />
      )}
    </div>
  );
};
